export default "__VITE_ASSET__C0_Alr2w__"